// src/components/About.jsx
import React from "react";
import { getPortfolioData } from "../../data/portfolioData";
import "./About.css";
import aboutImg from "../../assets/profile.png";
import Button from "../button/Button";
import { FaDownload } from "react-icons/fa";

const About = () => {
  const { herosection, about, contact } = getPortfolioData();

  const calculateAge = (dobString) => {
    const [day, month, year] = dobString.split('.');
    const dob = new Date(`${year}-${month}-${day}`);
    const today = new Date();

    let age = today.getFullYear() - dob.getFullYear();
    const m = today.getMonth() - dob.getMonth();

    if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
      age--;
    }

    return age;
  };


  return (
    <section className="about-section" id="about">
      <div className="about-container">
        <div className="about-left-container">
          <h2 className="section-title">About Me</h2>
          <h3 className="section-title-who">Who am i?</h3>
          <p className="about-summary">{about.summary}</p>

          <div className="about-details">
            <div className="content-row">
              <p className="label">Firstname: </p>
              <p>{herosection.firstName}</p>
            </div>
            <div className="content-row">
              <p className="label">Lastname: </p>
              <p>{herosection.lastName}</p>
            </div>
            <div className="content-row">
              <p className="label">Email: </p>
              <p>{contact.email}</p>
            </div>
            <div className="content-row">
              <p className="label">Phone: </p>
              <a href={"tel:" + contact.phone} className="phone-no">{"+91-" + contact.phone}</a>
            </div>
            <div className="content-row">
              <p className="label">Linked In: </p>
              <a href={contact.linkedIn} className="phone-no">Visit</a>
            </div>
            <div className="content-row">
              <p className="label">Languages: </p>
              <p>{about.languagesKnown.join(', ')}</p>
            </div>
            <div className="content-row">
              <p className="label">Age: </p>
              <p>{calculateAge(herosection.dateOfBirth)}</p>
            </div>

            <div className="content-row">
              <p className="label">Address: </p>
              <p>{contact.address}</p>
            </div>
            {/* <div className="skills">
              <h3>Skills</h3>
              <ul>
                {about.skills.map((skill, i) => (
                  <li key={i} className="skill-item">{skill}</li>
                ))}
              </ul>
            </div>

            <div className="languages">
              <h3>Languages Known</h3>
              <ul>
                {about.languagesKnown.map((lang, i) => (
                  <li key={i} className="language-item">{lang}</li>
                ))}
              </ul>
            </div> */}
          </div>
          <Button
            name={"Download Resume"}
            className={"send-msg"}
            icon={<FaDownload />}
            onClick={() => {
              const link = document.createElement("a");
              link.href = "https://janakrishnamoorthy.in/Janakrishnamoorthy_Resume.pdf";
              link.download = "Janakrishnamoorthy_Resume.pdf"; // file name after download
              link.click();
            }}
          />
        </div>
        <div className="about-right-container">
          <img src={aboutImg} alt="About Me" className="about-image" />
          <marquee behavior="scroll" direction="left" scrollamount="5">
            Welcome to My Portfolio — I’m a Freelance Web Developer!
          </marquee>
        </div>
      </div>
    </section>
  );
};

export default About;
